
export interface ENV{
    BASE_URL: string
    PASSWORD_RECOVERY_URL: string,
    JOBS_API_basePath: string,
    SSO_BaseUrl: string
}

declare global { interface Window {
    env: ENV;
}}


export default async ()=> {
    window.env = <ENV>await (await fetch('/env.json')).json();
};
